module.exports = __webpack_public_path__ + "img/ic_teachers-training.83179d6b.svg";